import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ShiftListPane } from '@apps/web/components/dashboard/shift_list_pane';
import { TrainingModePageTourScope } from '@apps/web/components/page_tour/training_mode_page_tour';
import { SHIFTS_PAGE_TOUR_STEPS } from '@apps/web/components/page_tour/training_mode_tour_configs';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export const shiftsSearchSchema = z.object({
    date: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    status: z.enum(['open', 'needs_coverage', 'needs_attention']).optional(),
    clientIds: z.array(z.string().uuid()).optional(),
    shiftId: z.string().optional(),
    approve: z.boolean().optional(),
    calloutShiftId: z.string().optional(),
    chatId: z.string().uuid().optional(),
    chatMode: z.enum(['fullscreen']).optional(),
    slackWebClaim: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/shifts/')({
    component: ShiftsPage,
    validateSearch: shiftsSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Shifts | Phoebe',
            },
        ],
    }),
});

function ShiftsPage() {
    const {
        date,
        from,
        to,
        status,
        clientIds,
        shiftId,
        approve,
        calloutShiftId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );
    const organizationId = useOrganizationId();

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return (
        <TrainingModePageTourScope
            pageId="shifts"
            organizationId={organizationId}
            ready={organizationId !== null}
            steps={SHIFTS_PAGE_TOUR_STEPS}
        >
            <ShiftListPane
                initialDate={date}
                initialFrom={from}
                initialTo={to}
                initialStatus={status}
                initialClientIds={clientIds}
                selectedShiftId={shiftId}
                showApproveModal={approve}
                calloutShiftId={calloutShiftId}
            />
        </TrainingModePageTourScope>
    );
}
